import type { HTMLAttributes, ReactNode } from 'react'
import styles from './Container.module.css'

export type ContainerSize = 'sm' | 'md' | 'lg' | 'xl'

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: ContainerSize
  children: ReactNode
}

export function Container({
  size = 'lg',
  children,
  className,
  ...props
}: ContainerProps) {
  const classes = [styles.container, styles[size], className]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  )
}
